

document.addEventListener('DOMContentLoaded', function () {
  const path = window.location.pathname;

  let videoUrl = "";
  let titleText = "";
  let noteText = "";

  if (path === "/de/pages/landing-b2b") {
    videoUrl = "https://cdn.shopify.com/videos/c/o/v/dbb773612ea744c184b39600e5e5fbc3.mp4";
    titleText = "Sehen Sie sich das Tutorial an, bevor Sie das Formular ausfüllen";
    // noteText = "Sehen Sie sich das Tutorial an, bevor Sie das Formular ausfüllen";
  } else if (path === "/pages/landing-b2b") {
    videoUrl = "https://cdn.shopify.com/videos/c/o/v/8bcbb394d6464a1687f24370d06ab6f3.mp4";
    titleText = "Guarda il tutorial prima di compilare il modulo";
    // noteText = "Guarda il tutorial prima di compilare il modulo";
  } else {
    return;
  }

  const container = document.querySelector(".left-content");
  if (!container) return;

  // tránh duplicate nếu re-render
  if (container.querySelector(".b2b-video-block")) return;

  // ===== Wrapper =====
  const wrapper = document.createElement("div");
  wrapper.className = "b2b-video-block";
  wrapper.style.background = "#fff";
  wrapper.style.borderRadius = "16px";
  wrapper.style.boxShadow = "0 8px 24px rgba(0,0,0,0.15)";
  wrapper.style.padding = "16px";
  wrapper.style.marginTop = "20px";

  // ===== Title =====
  const title = document.createElement("div");
  title.textContent = titleText;
  title.style.fontSize = "18px";
  title.style.color = "#000";
  title.style.fontWeight = "600";
  title.style.marginBottom = "12px";

  // ===== Video wrapper (để control height đẹp) =====
  const videoBox = document.createElement("div");
  videoBox.style.width = "100%";
  videoBox.style.height = "360px";
  videoBox.style.borderRadius = "12px";
  videoBox.style.overflow = "hidden";
  videoBox.style.background = "#000";

  // ===== Video =====
  const video = document.createElement("video");
  video.src = videoUrl;
  video.controls = true;
  video.autoplay = false;
  video.muted = false;
  video.loop = false;
  video.playsInline = true;
  video.style.width = "100%";
  video.style.height = "100%";
  video.style.objectFit = "cover";

  // ===== Note =====
  const note = document.createElement("div");
  note.textContent = noteText;
  note.style.fontSize = "14px";
  note.style.color = "#666";
  note.style.marginTop = "12px";

  // ===== Append =====
  videoBox.appendChild(video);
  wrapper.appendChild(title);
  wrapper.appendChild(note);

  wrapper.appendChild(videoBox);

  container.appendChild(wrapper);
});

function caculateSubtotalPDP() {
  const priceCell = document.querySelector(".price--medium .price__regular");
  const variantId = priceCell?.getAttribute("bss-b2b-variant-id");
  if (!variantId) return;

  const spans = priceCell?.querySelectorAll("span");
  const priceText = spans?.[1]?.textContent?.trim() || "";

  // ✅ Parse đúng số thập phân
  const numericPrice = parseFloat(
    priceText
      .replace(/[^\d.,]/g, "")
      .replace(",", ".")
  ) || 0;

  const qtyInput = document.querySelector(
    `.quantity__container input.quantity__input`
  );
  const quantity = parseFloat(qtyInput?.value || 1);

  const subtotalValue = numericPrice * quantity;

  // ✅ Format theo locale hiện tại (ví dụ EUR)
  const formattedSubtotal = subtotalValue.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const subtotalPrice = document.querySelector(
    `.productView-subtotal .money-subtotal[bss-b2b-variant-id="${variantId}"]`
  );

  const currencySymbol = priceText.replace(/[\d.,\s]/g, "");

  subtotalPrice.textContent = `${currencySymbol} ${formattedSubtotal}`;
}


document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const hasCpRule = Boolean(
      BSS_B2B?.cp?.utils?.common?.getCustomerAppliedRules().length
    );

    if (!hasCpRule) {
      return;
    }

    caculateSubtotalPDP();
  }, 3000);
});

let isFetching = false;

function toggleCheckout(disabled) {
    document.querySelectorAll('[name="checkout"], .checkout')
        .forEach(btn => {
            btn.disabled = disabled;
            btn.style.pointerEvents = disabled ? "none" : "auto";
            btn.style.opacity = disabled ? "0.5" : "1";
        });
}


function debounce(func, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
}


const updateCartNote = debounce((note) => {
    isFetching = true;

    fetch("/cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ note }),
    })
        .then(res => res.json())
        .catch(err => {
            console.error(err);
        })
        .finally(() => {
            isFetching = false;
            toggleCheckout(false);
        });

}, 300);


document.addEventListener("click", (e) => {
    const btn = e.target.closest('[name="checkout"], .checkout');

    if (btn && isFetching) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }
}, true);


document.addEventListener("DOMContentLoaded", () => {

    function init() {
        const textarea = document.getElementById("bss-cart-note-textarea");
        if (!textarea) return;

        textarea.addEventListener("input", (e) => {
            toggleCheckout(true); 
            updateCartNote(e.target.value);
        });
    }

    if (typeof BSS_B2B !== "undefined") {
        init();
    } else {
        const interval = setInterval(() => {
            if (typeof BSS_B2B !== "undefined") {
                clearInterval(interval);
                init();
            }
        }, 100);
    }
});



window.bssB2BHooks = window.bssB2BHooks || { actions: {}, filters: {} };

window.bssB2BHooks.filters["custom_validate_vat"] = function (isError, args) {
  try {
    if (!window.BSS_B2B || window.BSS_B2B.storeId !== 26549) return isError;

    const { form, field, dataMap } = args || {};
    if (field?.id !== "vat-validation") return isError;

    const countryCode = String(dataMap?.get("country-field") || form?.querySelector('[name="country-field"]')?.value || "").toUpperCase();
    const countryName = String(dataMap?.get("country-name") || form?.querySelector('[name="country-name"]')?.value || "").trim().toLowerCase();

    if (countryCode !== "SM" && countryName !== "san marino") return isError;

    window.BSS_B2B.rf.vatResult[field.id] = true;

    const input = form?.querySelector(`[name="${field.id}"]`);
    const wrapper = input?.closest(".bss-b2b-rf-field");
    const message = wrapper?.querySelector(".bss-message");

    if (input) input.style.borderColor = "";
    if (message) message.innerHTML = "";

    const hasOtherError = [...form.querySelectorAll(".bss-message")].some((el) => el !== message && el.textContent.trim());
    return hasOtherError ? true : false;
  } catch (e) {
    return isError;
  }
};